var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"json-preview"},[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.computedCode)}})])}
var staticRenderFns = []

export { render, staticRenderFns }